// src/routes/ShareRoutes.js
// import { lazy } from 'react';
// import Loadable from 'components/Loadable';
import SharedLiveVehiclePage from '../pages/shareMap/SharedLiveVehiclePage';
import SharedTripHistoryPage from '../pages/shareMap/SharedTripHistoryPage';

// const SharedLiveVehiclePage = Loadable(lazy(() => import('pages/shareMap/SharedLiveVehiclePage')));
// const SharedTripHistoryPage = Loadable(lazy(() => import('pages/shared/SharedTripHistoryPage')));

const ShareRoutes = {
  path: '/shared',
  children: [
    {
      path: 'live',
      element: <SharedLiveVehiclePage />
    },
    {
      path: 'trip',
      element: <SharedTripHistoryPage />
    }
  ]
};

export default ShareRoutes;
